import { get } from './APIHelper';

export const getAllTeamData = async sport => {
  return get(`proxy/api/v1/teams?sport=${sport}`);
};
